export default __webpack_public_path__ + "static/media/rulesChecklist.444efd90.png";